<template>
    <el-drawer title="一键批量退款" :visible.sync="visible" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
        <div class="drawer-content">
            <p class="tips">
                确认退款后，系统将自动进行退款，资金会原路返回至用户账户
            </p>
            <p class="tips">
                对于已经在支付平台成功退款的订单，则系统会自动退款状态，<span>但不会进行资金上的重复退款</span>
            </p>
            <div class="temp-table">
                <h3>退款汇总</h3>
                <el-table :data="tableData" size="mini" border show-summary>
                    <el-table-column prop="name" label="支付渠道">
                    </el-table-column>
                        <el-table-column label="后付款">
                            <el-table-column prop="AfterNum" label="数量"></el-table-column>
                            <el-table-column prop="After" label="金额"></el-table-column>
                        </el-table-column>
                        <el-table-column label="预付款">
                            <el-table-column prop="BeforeNum" label="数量"></el-table-column>
                            <el-table-column prop="Before" label="金额"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="Total" label="金额总计"></el-table-column>
                </el-table>              
            </div>            
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="sub" :loading="subLoading">对可退款演出进行退款</el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            data: null,
            tableData: [],
            // notRefundList: [],
            filter: {},
            subLoading: false
        }
    },
    methods: {
        show(data, filter) {
          this.data = data || [];
          this.filter = filter;          
          const list = Array.isArray(data) ? data : [];        
          this.tableData = list.map(item => ({
            name: item.platformName,
            AfterNum: Number(item.afterNum) || 0,
            After: Number(item.afterAmount) || 0,
            BeforeNum: Number(item.beforeNum) || 0,
            Before: Number(item.beforeAmount) || 0,
            Total: (Number(item.afterAmount) || 0) + (Number(item.beforeAmount) || 0)
          }));        
          this.visible = true;
        },
        close() {
            this.data = null;
            this.tableData = [];
            // this.notRefundList = [];
            this.filter = {};
            this.visible = false;
        },
        async sub() {
            let _isReconciliationSuccess = 0;
            await this.reconciliationCheck(async (data) => {
                if (data && data != 0) {
                    const flag = await this.$confirm(`系统检测到本次退款的数据包含<span class='color-danger'>${data}条</span>未收入对账或对账失败的数据，请选择处理方式`, "警报", {
                        confirmButtonText: '全部批量退款',
                        cancelButtonText: '只批量退对账成功',
                        center: true,
                        dangerouslyUseHTMLString: true,
                        distinguishCancelAndClose: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).catch((action) => { return action });
                    if (flag === 'cancel') {
                        _isReconciliationSuccess = 1;
                    } else if (flag === 'close') {
                        return;
                    }
                }
                this.subLoading = true;
                const res = await this.$request({
                    url: '/activity/refund/batch/createTask',
                    method: 'post',
                    data: { ...this.filter, isReconciliationSuccess: _isReconciliationSuccess }
                }).catch(() => {
                    return { data: { state: '0', msg: '请求错误' } };
                }).finally(() => {
                    this.subLoading = false;
                });

                const { state, msg } = res.data;

                if (state !== '1') {
                    return this.$message.error(msg || '请求失败');
                }

                this.$emit('subSuccess');
                this.close();
            })

        },
        // 退款前检测
        async reconciliationCheck(callback) {
            const { filter } = this;
            const res = await this.$request({
                url: '/activity/refund/batch/reconciliationCheck',
                method: 'post',
                data: filter,
            }).catch(() => {
                return { data: { state: '0', msg: '请求错误' } };
            });

            const { state, msg, result } = res.data;

            if (state != 1) {
                return this.$message.error(msg || '操作失败');
            } else {
                callback && callback(result)
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.tips span {
    color: #f56c6c;
}

.temp-table h3 {
    margin: 20px 0 10px 0;
}
</style>